import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildReviewsDataTableFilter,
  useReviewsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

export const byAuthorFilter = (source: ReturnType<typeof useReviewsDataTable>) => {
  const access = users.current
  const accessId = access.id

  const options = [
    {
      label: i18n.t('surveys.review.index.table.filters.created_by_me'),
      value: accessId,
      component: (
        <Text.Normal>{i18n.t('surveys.review.index.table.filters.created_by_me')}</Text.Normal>
      ),
    },
  ]

  return buildReviewsDataTableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'byAuthorFilter',
    path: 'authorId',
    title: i18n.t('surveys.review.index.table.filters.created_by'),
  })
}
